export class ProcessInstanceRuntime {
    ProcessXML: string;
    ChildActivityInstances: string[];
    Variables: { [variable: string]: any; };
}